import { UnderconstructionIllustration } from "vega-illustrations";

import { ThemedButton } from "@vega-core/components/Buttons/ThemedButton";
import { usePublicConfig } from "@vega-core/hooks/usePublicConfig";
import { m } from "@vega-core/paraglide/messages";

import { LPPageContainerWithNavigation } from "../../components/PageContainerWithNavigation/PageContainerWithNavigation";

export function PrivatePageError() {
  const {
    contacts: { helpEmail },
  } = usePublicConfig();

  return (
    <LPPageContainerWithNavigation>
      <div className="h-full flex items-center justify-center">
        <div className="w-full bg-background/secondary flex justify-center p-8 rounded-companyBorderRadius">
          <div className="max-w-[90vw] md:max-w-96 text-center flex flex-col gap-6 items-center">
            <div>
              <UnderconstructionIllustration className="max-w-[100vw]" />
            </div>
            <div className="body-base-regular text-text/secondary p-4">
              {m.errors_pageCrashedMessage()}
              <a
                className="underline text-brand-default"
                href={`mailto:${helpEmail}`}
              >
                {helpEmail}
              </a>
            </div>
            <div className="w-36">
              <ThemedButton
                dataTestId="refresh-button"
                fullWidth
                onClick={() => location.reload()}
                variant="primary"
              >
                {m.btn_refreshPage()}
              </ThemedButton>
            </div>
          </div>
        </div>
      </div>
    </LPPageContainerWithNavigation>
  );
}
